import { render, staticRenderFns } from "./uploadImgs4.vue?vue&type=template&id=24c89ee6&scoped=true&"
import script from "./uploadImgs4.vue?vue&type=script&lang=js&"
export * from "./uploadImgs4.vue?vue&type=script&lang=js&"
import style0 from "./uploadImgs4.vue?vue&type=style&index=0&id=24c89ee6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c89ee6",
  null
  
)

export default component.exports